import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { useState, useMemo } from 'react';
import { useChartPeriod } from '@/hooks';
import { FormattedNumber, LineChart, formatNumber } from '@blockanalitica/ui';

export default function CdpsChart({ ilk }: { ilk: string }) {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const yAxisConfig = {
    options: {
      scales: {
        y: {
          ticks: {
            stepSize: 1
          }
        }
      }
    }
  };
  const config = updateChartConfigWithPeriod(yAxisConfig);
  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const [data, error] = useApi({
    url: `/groups/core/ilks/${ilk}/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <LineChart
        key="num_urns"
        data={data}
        datasets={[
          {
            xField: 'date',
            yField: 'num_urns'
          }
        ]}
        valueFormatter={(value: number) => (
          <FormattedNumber
            value={Number(value)}
            options={{ formatNumberOptions: { notation: 'standard' } }}
          />
        )}
        yScaleValueFormatter={(value: number) =>
          formatNumber(value, { notation: 'standard' })
        }
        timeFilter={timeFilter}
        config={config}
      />
    );
  }

  return <ChartSkeleton />;
}
